import { service } from '@ember/service';
import Component from '@glimmer/component';

import { eq, or } from 'ember-truth-helpers';

import Background from 'umg-ember-backend/components/page-builder/options/form/section/background';
import CustomOptions from 'umg-ember-backend/components/page-builder/options/form/section/custom-options';
import DisplayOptions from 'umg-ember-backend/components/page-builder/options/form/section/display-options';
import Headline from 'umg-ember-backend/components/page-builder/options/form/section/headline';
import Selectors from 'umg-ember-backend/components/page-builder/options/form/section/selectors';
import Text from 'umg-ember-backend/components/page-builder/options/form/section/text';

export default class PageBuilderOptionsFormsContentItemProduct extends Component {
  // Services
  @service intl;

  // Template
  <template>
    <DisplayOptions
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
    <Text @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
    <Headline @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
    {{#if (or (eq @form.model.options.style 'CUSTOM') @mlp.isV2)}}
      <Background
        @form={{@form}}
        @elementConfig={{@elementConfig}}
        @mlp={{@mlp}}
      />
    {{/if}}
    <Selectors
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
    <CustomOptions
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
  </template>
}
